/* styles */

/* components */
import { Box, Hidden } from '@mui/material'
import MenuListMobile from './MenuListMobile/MenuListMobile'
import ProfileMenuMobile from './ProfileMenuMobile/ProfileMenuMobile'
import SearchMobile from './SearchMobile/SearchMobile'
import ToggleMobile from './ToggleMobile/ToggleMobile'
import useStyles from './useStyles'

function HeaderMobile () {
  const classes = useStyles()

  return (
    <>
      <Hidden mdUp>
        <Box className={classes.fixedContainer}>
          <Box className={classes.containerMobile}>
            <Box className={classes.toggleContainer}>
              <ToggleMobile />
              <SearchMobile />
            </Box>
            <ProfileMenuMobile />
          </Box>
        </Box>
        <MenuListMobile />
      </Hidden>
    </>
  )
}
export default HeaderMobile
